import httpClient from 'shared/utils/http-client'
import { SalesFunnelsSettingsInterface } from 'modules/profile/sales-funnels-settings/types/sales-funnels-settings-interface'

export const SALES_FUNNELS_SETTINGS_API = '/api/dashboard/customer/settings/sales-funnels'

export const updateSalesFunnelSettings = (data: SalesFunnelsSettingsInterface) =>
  httpClient.put(SALES_FUNNELS_SETTINGS_API, data)
